import React from 'react';
import { FaStar, FaLanguage, FaClock, FaCertificate } from 'react-icons/fa'; // Icons for various details
import { BsCurrencyRupee } from 'react-icons/bs'; // Rupee symbol
import automotiveImg from '../../assets/images/automobile.webp';
import { useNavigate, useParams } from 'react-router-dom';

const MyCourseCard = ({ course, index }) => {
    const navigate = useNavigate();

    return (
        <>
            <div style={styles.card} onClick={() => { navigate("/course/" + course.id); console.log("clicked") }}>
                {/* Card Image */}
                <img
                    src={course?.thumbnailUrl} // Replace this with actual image URL
                    alt="Course Thumbnail"
                    style={styles.image}
                />

                {/* Course Content */}
                <div style={styles.content}>
                    <h3 style={styles.title}>{course?.title}</h3>
                    <p style={styles.description}>
                        {course?.shortDesc}
                    </p>

                    <h5 style={styles.sector}>{course?.subCategoryName}</h5>

                    {/* Course Details */}
                    <div style={styles.details}>
                        <p><FaLanguage /> {course?.language}</p>
                        <p><FaClock /> {course?.duration} Hours</p>
                        <p><FaStar /> Beginner</p>
                        <p><FaCertificate /> Certificate</p>
                    </div>

                    {/* Rating and Price */}
                    {/* <div style={styles.footer}>
                        <div style={styles.rating}>
                            <span style={styles.ratingValue}>4.4</span>
                            <FaStar style={styles.starIcon} />
                            <span>(1,478 ratings)</span>
                        </div>
                        <div style={styles.price}>
                            <BsCurrencyRupee /> 4999
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

// CSS-like styles
const styles = {
    card: {
        border: '1px solid #ddd',
        borderRadius: '10px',
        width: '300px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        cursor: 'pointer',
    },
    image: {
        width: '100%',
        height: '40%',
    },
    content: {
        padding: '15px',
    },
    title: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '8px',
    },
    description: {
        fontSize: '14px',
        color: '#666',
        marginBottom: '10px',
    },
    sector: {
        fontSize: '16px',
        color: '#0056b3', // Blue color for sector text
        marginBottom: '10px',
    },
    details: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '14px',
        color: '#333',
        marginBottom: '15px',
    },
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    rating: {
        display: 'flex',
        alignItems: 'center',
    },
    ratingValue: {
        fontWeight: 'bold',
        marginRight: '5px',
    },
    starIcon: {
        color: '#ffc107', // Gold star color
        marginRight: '5px',
    },
    price: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#333',
    },
};

export default MyCourseCard;

